<template>
    <div class="office-overtime office-overtime__container container-fluid">
        <div class="card">
            <div class="card-body">
                <form
                    class="row office-overtime__search"
                    action=""
                    @submit.prevent="searchOvertimeLogs"
                >
                    <div class="col-md-2 col-sm-12">
                        <label>Search</label>
                        <input
                            type="search"
                            class="form-control"
                            placeholder="Search Loaction..."
                            v-model="params.search"
                        >
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>User</label>
                        <user-select
                            v-if="users.length"
                            v-model="params.user_id"
                            :options="users"
                            :office="false"
                            :admins="false"
                            :autoselect="false"
                        />
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>Status</label>
                        <select
                            class="form-control"
                            v-model="params.verified"
                        >
                            <option value="all">
                                All
                            </option>
                            <option value="unverified">
                                Unverified
                            </option>
                            <option value="verified">
                                Verified
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>From Date</label>
                        <date-picker v-model="params.from_date" />
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>To Date</label>
                        <date-picker v-model="params.to_date" />
                    </div>
                    <div class="col-md-2 col-sm-12 text-right">
                        <br>
                        <button
                            class="btn btn-primary"
                            v-if="!loading"
                        >
                            Search
                        </button>
                        <button
                            class="btn btn-primary"
                            v-if="loading"
                            disabled
                        >
                            Loading...
                        </button>
                        <button
                            class="btn btn-default"
                            @click.prevent="clearSearch"
                        >
                            Clear
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <table
                    class="table"
                    v-if="loaded && users"
                >
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Vehicle</th>
                            <th>Location</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Duration</th>
                            <th>Overtime</th>
                            <th style="width: 7rem">
                                Out of Hours Emergency
                            </th>
                            <th style="width: 7rem">
                                Overnight Stay
                            </th>
                            <th>Verification</th>
                            <th class="text-right">
                                <select
                                    v-model="params.per_page"
                                    @input="searchOvertimeLogs"
                                    class="form-control text-right"
                                    style="width: 10rem; display: inline-block;"
                                >
                                    <option value="25">
                                        25 per page
                                    </option>
                                    <option value="50">
                                        50 per page
                                    </option>
                                    <option value="100">
                                        100 per page
                                    </option>
                                </select>
                            </th>
                        </tr>
                        <tr>
                            <th
                                class="underline"
                                colspan="5"
                            >
                                Total
                            </th>
                            <th class="underline">
                                {{ durationTotal | minsToHours }}
                            </th>
                            <th class="underline">
                                {{ overtimeTotal | minsToHours }}
                            </th>
                            <th
                                colspan="4"
                                class="text-right"
                            >
                                <button
                                    class="btn btn-success"
                                    @click.prevent="addRow"
                                    v-if="canAddRow"
                                >
                                    Add Row
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!loading && !logs.length">
                            <td colspan="11">
                                No overtime logs to show for current filter, try
                                <a
                                    href="#"
                                    @click.prevent="clearSearch"
                                >clearing</a>
                                your filter or
                                <a
                                    href="#"
                                    @click.prevent="extendFromDate"
                                >extending start date</a>
                            </td>
                        </tr>
                        <log-row
                            v-for="(log, index) in logs"
                            :key="log.id"
                            :log="log"
                            :users="users"
                            :vehicles="vehicles"
                            :vehicles-loading="vehiclesLoading"
                            @deleted="deleteLog(index)"
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <th
                                class="underline"
                                colspan="5"
                            >
                                Total
                            </th>
                            <th class="underline">
                                {{ durationTotal | minsToHours }}
                            </th>
                            <th class="underline">
                                {{ overtimeTotal | minsToHours }}
                            </th>
                            <th colspan="4">
&nbsp;
                            </th>
                        </tr>
                    </tfoot>
                </table>

                <pagination
                    :page="params.page"
                    :last-page="lastPage"
                    v-if="loaded"
                    @pageChange="pageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import OvertimeService from '../../../services/OvertimeService';
import UserSelect from '../../UserSelectComponent';
import DatePicker from '../../DateTimePickerComponent';
import LogRow from './RowComponent';
import Pagination from '../../PaginationComponent';
import { mapActions } from 'vuex';
import UsersService from '../../../services/UsersService';
import AuthService from '../../../services/AuthService';
import VehicleService from '../../../services/VehicleService';
export default {
    components: {
        UserSelect,
        DatePicker,
        LogRow,
        Pagination,
    },
    data () {
        return {
            loading: false,
            loaded: false,
            params: {
                search: '',
                page: 1,
                user_id: null,
                verified: 'all',
                per_page: 25,
                from_date: window.moment().startOf('month'),
            },
            logs: [],
            total: 0,
            lastPage: 1,
            users: [],
            vehicles: [],
            vehiclesLoading: true,
        };
    },
    computed : {
        durationTotal () {
            let mins = 0;
            this.logs.forEach(log => {
                mins += window.moment(log.end_time).diff(window.moment(log.start_time), 'minutes');
            });

            return mins;
        },
        overtimeTotal () {
            let mins = 0;
            this.logs.forEach(log => {
                mins += this.$store.getters['overtime/getOvertimeMins'](log);
            });

            return mins;
        },
        canAddRow () {
            return AuthService.user.admin_access;
        },
    },
    mounted () {
        this.loadOvertimeLogs();
        // OfficeComponent owns the overtime-logs Echo subscription and relays events via $root.
        this.$root.$on('OvertimeLogUpdated', this.onOvertimeLogUpdated);
        this.$root.$on('OvertimeLogDeleted', this.onOvertimeLogDeleted);
        this.loadOvertimeSettings();
        UsersService.engineers().then(res => {
            this.users = res.data;
        });
        VehicleService.index().then(res => {
            this.vehicles = res.data;
            this.vehiclesLoading = false;
        });
    },
    beforeDestroy () {
        this.$root.$off('OvertimeLogUpdated', this.onOvertimeLogUpdated);
        this.$root.$off('OvertimeLogDeleted', this.onOvertimeLogDeleted);
    },
    methods: {
        ...mapActions('overtime', ['loadOvertimeSettings']),
        searchOvertimeLogs () {
            this.params.page = 1;
            this.loadOvertimeLogs();
        },
        loadOvertimeLogs () {
            this.loading = true;
            const params = {...this.params};
            params.from_date = params.from_date ? params.from_date.format('YYYY-MM-DD HH:mm') : null;
            params.to_date = params.to_date ? params.to_date.format('YYYY-MM-DD HH:mm') : null;
            OvertimeService.index(params).then(res => {
                this.logs = res.data.data;
                this.total = res.data.total;
                this.lastPage = res.data.last_page;
                this.loading = false;
                this.loaded = true;
            })
        },
        pageChange (page) {
            this.params.page = page;
            this.loadOvertimeLogs();
        },
        clearSearch () {
            this.params = {
                search: '',
                page: 1,
                user_id: null,
                verified: 'all',
                from_date: window.moment().startOf('month'),
                to_date: null,
                per_page: this.params.per_page || 25,
            };
            this.loadOvertimeLogs();
        },
        extendFromDate () {
            if (this.params.from_date) {
                this.params.from_date = window.moment(this.params.from_date)
                    .subtract(1, 'month')
                    .startOf('month');
            } else {
                this.params.from_date = window.moment()
                    .subtract(1, 'month')
                    .startOf('month');
            }
            this.searchOvertimeLogs();
        },
        onOvertimeLogUpdated (event) {
            var i = this.logs.findIndex(log => log.id === event.log.id);
            if (i >= 0) {
                this.logs[i] = event.log;
                this.$forceUpdate();
            }
        },
        onOvertimeLogDeleted (event) {
            var i = this.logs.findIndex(log => log.id === event.log.id);
            if (i >= 0) {
                this.logs.splice(i, 1);
                this.$forceUpdate();
            }
        },
        addRow () {
            this.logs.unshift({

            });
        },
        deleteLog (index) {
            this.logs.splice(index, 1);
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/overtime/IndexComponent.vue